// The catalog page's view lens — ONE predicate the grid and the export loader
// both judge rows through (the one-lens rule for derived filters, BACKEND-
// PATTERNS §Import/export engine): availability (the hidden exception chip) ·
// usage (in use here / unused) · category · tier · capability. The search
// fields beside it (`assetModelSearchFields`) ride the shared word rules — the
// grid, the export and the server's own search columns name the same fields.
export function assetModelMatches(m, f) {
    return (
    // The fetch carries hidden rows so the exception chip can count + reveal
    // them; the DEFAULT view excludes them.
    (f.availability.includes('hidden') ? m.is_disabled : !m.is_disabled) &&
        (f.usage.length === 0 || (f.usage[0] === 'inuse' ? m.in_use_count > 0 : m.in_use_count === 0)) &&
        (f.category.length === 0 || f.category.includes(m.category)) &&
        (f.tier.length === 0 || f.tier.includes(m.is_canonical ? 'canonical' : 'local')) &&
        (f.capability.length === 0 || f.capability.some((c) => m.capabilities.includes(c))));
}
/** The fields a catalog row is searched by, on both faces (ADR-072 §6 · ADR-045): the NAME is make + product (a
 *  mistake forgiven), the CODES are the series and the part number — matched as typed, never forgiven. The server's
 *  generated `search_name` / `search_ref` columns hold the same split. The part number is no KEY: a vendor's prefix
 *  P/N is shared across variants (the schema says so), and a key names ONE row. */
export function assetModelSearchFields(m) {
    return { name: [m.manufacturer, m.name].filter(Boolean).join(' '), codes: [m.series, m.part_number] };
}
